import { useEffect, useState } from "react";
import api, { inr, fmtDateTime } from "@/api";

export default function EmpExpenses() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/expenses").then((r) => setItems(r.data)); }, []);
  const total = items.reduce((s, e) => s + e.amount, 0);
  return (
    <div className="p-5 space-y-5" data-testid="emp-expenses-page">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-xs uppercase tracking-widest text-muted-foreground">My Expenses</div>
          <h1 className="font-heading text-xl font-bold font-mono">{inr(total)}</h1>
        </div>
        <div className="text-xs text-muted-foreground">{items.length} entries</div>
      </div>
      <p className="text-xs text-muted-foreground">Add expenses from inside a job (Jobs → open job → Add Expense).</p>
      <div className="space-y-2" data-testid="emp-expenses-list">
        {items.map((e) => (
          <div key={e.id} className="bg-surface border border-border rounded-xl p-4 flex items-center justify-between">
            <div>
              <div className="font-medium text-sm capitalize">{e.category} {e.note && <span className="text-muted-foreground">· {e.note}</span>}</div>
              <div className="text-xs text-muted-foreground font-mono mt-0.5">{e.job_no} · {fmtDateTime(e.created_at)}</div>
            </div>
            <b className="font-mono">{inr(e.amount)}</b>
          </div>
        ))}
        {items.length === 0 && <div className="text-center text-muted-foreground text-sm py-10 bg-surface rounded-2xl border border-border">No expenses yet</div>}
      </div>
    </div>
  );
}
